<template>
  <DialogModal
    ref="dialog"
    :dismissible="false"
    size="sm"
  >
    <template #title>Para sua segurança, altere a senha</template>

    <div class="flex flex-col gap-3">
      <p class="text-sm text-gray-600">Defina uma nova senha para continuar usando o sistema.</p>

      <input
        v-model="password"
        class="form-control"
        placeholder="Nova senha"
        type="password"
      />
      <input
        v-model="passwordConfirmation"
        class="form-control"
        placeholder="Confirmar nova senha"
        type="password"
      />

      <div
        v-if="errorMsg"
        class="text-sm text-red-600"
      >
        {{ errorMsg }}
      </div>
    </div>

    <template #buttons>
      <button
        class="btn btn-primary"
        :disabled="submitting"
        type="button"
        @click="submit"
      >
        Salvar
      </button>
    </template>
  </DialogModal>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import axios from "axios";
import { useNotification } from "@/composables/notify.js";
import authStore from "@/store/auth.js";
import DialogModal from "@/components/comum/DialogModal.vue";

const { notify } = useNotification();

const dialog = ref<InstanceType<typeof DialogModal>>();
const password = ref("");
const passwordConfirmation = ref("");
const errorMsg = ref("");
const submitting = ref(false);

onMounted(() => {
  dialog.value!.openDialog();
});

const validate = (): string => {
  if (password.value.length < 8) return "A senha deve ter no mínimo 8 caracteres";
  if (password.value === "secret") return "Sua senha não pode ser secret";
  if (password.value !== passwordConfirmation.value) return "As senhas não conferem";
  return "";
};

const submit = async () => {
  errorMsg.value = validate();
  if (errorMsg.value) return;

  try {
    submitting.value = true;
    await axios.put("/api/user/change-password", { password: password.value });
    await authStore.currentUserRequest();
    notify({ text: "Senha alterada com sucesso", type: "success" });
  } catch (error: any) {
    errorMsg.value = error.response?.data?.message ?? "Erro ao alterar senha";
  } finally {
    submitting.value = false;
  }
};
</script>
